export const municipalities = ["Arlington", "Boston", "Cambridge", "Quincy", "Somerville", "Medford","Brookline"];
export default municipalities;
